import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'
import Home from './components/Home'
import Detail from './components/Detail'
import PasswordSecurity from './components/Detail/PasswordSecurity'
import Contracts from './components/Detail/Contracts'
import WorkingProcess from './components/Detail/WorkingProcess'
import MyIncomes from './components/MyIncomes'
import MyRatings from './components/MyRatings'
import CustomerEvents from './components/CustomerEvents'
import Regulations from './components/Detail/Regulations'
import ReferralSummary from './components/ReferralSummary'

const AccountModule: RouteObject = {
    path: 'account',
    children: [
        {
            path: '',
            element: <Home />,
        },
        {
            path: 'info',
            element: <Detail />,
        },
        {
            path: 'password-security',
            element: <PasswordSecurity />,
        },
        {
            path: 'contracts',
            element: <Contracts />,
        },
        {
            path: 'working-process',
            element: <WorkingProcess />,
        },
        {
            path: 'my-incomes',
            element: <MyIncomes />,
        },
        {
            path: 'my-ratings',
            element: <MyRatings />,
        },
        {
            path: 'customer-events',
            element: <CustomerEvents />,
        },
        {
            path: 'regulations',
            element: <Regulations />,
        },
        {
            path: 'referral',
            element: <ReferralSummary />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default AccountModule
